<template>
  <v-dialog v-model="dialog" class="primary darken-1">
    <v-card class="pt-4 px-6 primary darken-1">
      <div
        class="mb-3"
        style="
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <h1 style="font-weight: bold; font-size: 20px; line-height: 23px">
          Localização das estações
        </h1>
        <v-btn
          class="button-text secondary--text text--lighten-1"
          text
          @click="dialog = false"
        >
          <v-icon class="mr-1" size="20">mdi-close-circle-outline</v-icon>
          <span>Fechar</span>
        </v-btn>
      </div>
      <div class="pb-6">
        <new-ol-map-base
          ref="mapBase"
          :mapId="mapId"
          :layers="stationsDataLayers"
          :showMapMenu="false"
          @onMapReady="onMapReady($event)"
          @mapPointerMove="onPointerMove($event)"
          mapHeight="600px"
        >
        </new-ol-map-base>

        <tooltip-card-stations-map
          v-show="map"
          :tooltipId="tooltipId"
          :tooltipParams="tooltipParams"
        >
        </tooltip-card-stations-map>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import 'ol/ol.css';
import {TileWMS} from 'ol/source';
import {
  getTooltipPropertiesOfLayer,
  getTooltipPropertiesFromFeature,
  initHighlightStyle,
} from '@/ol-maps/functions';
import {getSublayers, getDataFeatures, addOverlayMap} from '@/ol-maps/factory';
import NewOlMapBase from '../common/NewOlMapBase';
import TooltipCardStationsMap from './TooltipCardStationsMap.vue';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
export default {
  name: 'ViewStationsMap',
  props: ['type'],
  components: {NewOlMapBase, TooltipCardStationsMap},
  data: () => ({
    view: undefined,
    map: undefined,
    overlaysGroup: [],
    overlayTooltipText: undefined,
    overlayLayerTooltip: undefined,
    tooltipParams: [],
    flag: undefined,
    overlayLayerTooltipCard: undefined,
    featureOverlay: undefined,
    dialog: false,
  }),
  watch: {
    dialog(value) {
      if (value && !this.map) {
        this.initialize();
      }
    },
  },
  computed: {
    stationsDataLayers() {
      return this.$store.getters.stationsDataLayers;
    },
    mapId() {
      return `${this.type}-map`;
    },
    tooltipId() {
      return `${this.type}-tooltip-card`;
    },
  },
  //created () { this.initialize() },
  methods: {
    async initialize() {
      await this.$store.dispatch('loadStationsDataLayers');
      this.overlaysGroup = await getSublayers(this.stationsDataLayers);
      this.$refs.mapBase.initialize();
    },
    onMapReady(value) {
      const {map, view} = value;
      this.map = map;
      this.view = view;
      this.addTooltipOverlay();
      this.$refs.mapBase.checkMapModal();
    },
    async onPointerMove(e) {
      const me = this;
      this.flag = e.pixel;

      if (this.featureOverlay) {
        this.featureOverlay.getSource().clear(true);
      }

      await new Promise((r) => setTimeout(r, 100));
      if (this.flag != e.pixel) {
        return;
      }
      this.flag = undefined;

      let pixel = me.map.getEventPixel(e.originalEvent);
      me.clearTooltipParams();
      // eslint-disable-next-line no-unused-vars
      me.map.forEachLayerAtPixel(pixel, function (layer, r) {
        const source = layer.getSource();
        const propertiesLayer = layer.getProperties();
        if (
          source instanceof TileWMS &&
          propertiesLayer.tooltip_params &&
          !propertiesLayer.hide_on_menu
        ) {
          const view = me.map.getView();
          const fetchData = async () => {
            const features = await getDataFeatures(e, source, view);
            // highlightStyle
            let feature = features[0];
            if (feature && propertiesLayer) {
              if (propertiesLayer.property_params) {
                if (propertiesLayer.property_params.highlightOnHoverFeature) {
                  let show_highlights =
                    propertiesLayer.property_params.highlightOnHoverFeature;

                  let vectorSource = new VectorSource({
                    features: new GeoJSON().readFeatures(feature),
                  });

                  // add highlights
                  if (show_highlights) {
                    const {fillColor, strokeColor} = show_highlights;
                    if (me.featureOverlay) {
                      me.featureOverlay.getSource().clear(true);
                    }
                    me.featureOverlay = initHighlightStyle(
                      me.map,
                      fillColor,
                      strokeColor,
                    );
                    me.featureOverlay.setSource(vectorSource);
                  }
                }
              }
            }
            // highlightStyle
            document.getElementById(me.mapId).style.cursor = 'pointer'; // map cursor style
            if (features && features.length > 0) {
              const {keys, icon_params} =
                getTooltipPropertiesOfLayer(propertiesLayer);
              features.forEach((feature_properties) => {
                me.addTooltipParams({
                  ...getTooltipPropertiesFromFeature(
                    keys,
                    feature_properties.properties,
                  ),
                  name: propertiesLayer.name,
                  zindex: propertiesLayer.property_params.zindex,
                  updatedAt:
                    feature_properties.properties.date ??
                    feature_properties.properties.date,
                  icon_params: propertiesLayer.icon_params
                    ? propertiesLayer.icon_params
                    : icon_params,
                });
              });
              me.overlayLayerTooltipCard.setPosition(e.coordinate);
            } else {
              document.getElementById(me.mapId).style.cursor = ''; // map cursor style
              //this.featureOverlay.getSource().clear(true);
            }
          };
          fetchData();
        }
      });

      if (this.tooltipParams.length === 0) {
        me.overlayLayerTooltipCard.setPosition(undefined);
      }
    },
    addTooltipOverlay() {
      const tooltipCard = document.getElementById(this.tooltipId);
      this.overlayLayerTooltipCard = addOverlayMap(
        this.map,
        tooltipCard,
        'bottom-center',
      );
    },
    addTooltipParams(params) {
      this.tooltipParams.push(params);
    },
    clearTooltipParams() {
      this.tooltipParams = [];
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    openMapDialog(value) {
      this.dialog = value;
    },
  },
};
</script>

<style scoped></style>
